var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerBoxMultiple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 5.41667C7.58398 4.84203 7.81226 4.29093 8.21859 3.8846C8.62491 3.47827 9.17602 3.25 9.75065 3.25H20.584C21.1586 3.25 21.7097 3.47827 22.116 3.8846C22.5224 4.29093 22.7506 4.84203 22.7506 5.41667V16.25C22.7506 16.8246 22.5224 17.3757 22.116 17.7821C21.7097 18.1884 21.1586 18.4167 20.584 18.4167H9.75065C9.17602 18.4167 8.62491 18.1884 8.21859 17.7821C7.81226 17.3757 7.58398 16.8246 7.58398 16.25V5.41667Z",
    stroke: "#FF7A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 18.4173V20.584C18.4167 21.1586 18.1884 21.7097 17.7821 22.116C17.3757 22.5224 16.8246 22.7506 16.25 22.7506H5.41667C4.84203 22.7506 4.29093 22.5224 3.8846 22.116C3.47827 21.7097 3.25 21.1586 3.25 20.584V9.75065C3.25 9.17602 3.47827 8.62491 3.8846 8.21859C4.29093 7.81226 4.84203 7.58398 5.41667 7.58398H7.58333",
    stroke: "#FF7A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerBoxMultiple);
export default __webpack_public_path__ + "static/media/tabler_box-multiple.9385e16ba2de922b98b80e2c38b808ac.svg";
export { ForwardRef as ReactComponent };